"use client";
import { Page } from "~/use-cases/contracts/Page";
import { ParagraphCollection } from "../components/crystallize-components/paragraph-collection";
import { AccordionCollection } from "../components/crystallize-components/accordion-collection";

export default ({ data: page }: { data: Page }) => {
  return (
    <>
      <div className="2xl px-4 lg:px-6 container mx-auto frntr-page mb-24 mt-16">
        <div className="max-w-[1000px] mx-auto">
          <h1 className="text-4xl lg:text-6xl font-semibold mb-2">
            {page.title}
          </h1>
          {page.content && <ParagraphCollection paragraphs={page.content} />}
          {page.accordion && (
            <AccordionCollection paragraphs={page.accordion} />
          )}
        </div>
      </div>
    </>
  );
};
